<template>
  <div class="welcome-msg" :class="wrapperClass">
    <div class="row items-start">
      <img v-if="showLogo"
        src="/android-chrome-512x512.png" 
        alt="AI4SoilHealth Logo"
        class="welcome-logo"
      />
      <div class="col">
        <div class="text-h5 text-weight-medium" :class="titleClass">
          {{ $t('Hi') }}, {{ firstName }}
        </div>
        <div class="welcome-subtitle" :class="subtitleClass">
          {{ $t('See the last layer you explored') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  firstName: {
    type: String,
    default: 'Guest'
  },
  showLogo: {
    type: Boolean,
    default: true
  },
  wrapperClass: {
    type: String,
    default: ''
  },
  subtitleClass: {
    type: String,
    default: ''
  },
  titleClass: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.welcome-logo {
  width: 3.5rem;
  height: 3.5rem;
  object-fit: contain;
  flex-shrink: 0;
  margin-left: -0.625rem;
}

.welcome-subtitle {
  color: $grey-6;

  body.body--dark & {
    color: $grey-5;
  }
}
</style>